import React from "react";
import { Link } from "react-router-dom";

export default function Sidebar({ dashboards = [], tables = [] }) {
  return (
    <div className="w-64 bg-gray-100 p-4 overflow-auto">
      <h2 className="font-bold mb-2">Darbvirsmas</h2>
      {dashboards.map(d => (
        <Link key={d.path} to={d.path} className="block p-2 hover:bg-gray-200 rounded">
          {d.name}
        </Link>
      ))}

      <Link key="/logout" to="/logout" className="block p-2 mt-6 hover:bg-gray-200 rounded">
        Iziet
      </Link> 

      {/*
      <h2 className="font-bold mt-6 mb-2">Tables</h2>
      {tables.map(t => (
        <Link key={t} to={`/table/${encodeURIComponent(t)}`} className="block p-2 hover:bg-gray-200 rounded">
          {t}
        </Link>
      ))}*/}
    </div>
  );
}
